import { useQuery } from "@tanstack/react-query";
import { topicsApi } from "@/lib/humhub-api/topics";
import { channelKeys } from "@/lib/queryKeys/channelKeys";

export const useTopicChannels = (studyGroupId: number | null | undefined) => {
  return useQuery({
    queryKey: channelKeys.topicChannels(studyGroupId ?? "none"),
    queryFn: () => topicsApi.getChannels(studyGroupId as number),
    enabled: typeof studyGroupId === "number" && studyGroupId > 0,
    staleTime: 5 * 60 * 1000,
  });
};
